const style = {
  // ... (estilos existentes de container até contentGrid)
  container: {
    width: "100%",
    padding: "20px",
    color: "#E6EDF3",
  },
  loadingContainer: {
    color: "white",
    textAlign: "center",
    padding: "50px",
    fontSize: "18px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "40px",
  },
  title: {
    fontSize: "32px",
    fontWeight: "600",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: "#8B949E",
    margin: 0,
  },
  backButton: {
    background: "transparent",
    border: "1px solid #30363D",
    color: "#8B949E",
    fontSize: "14px",
    cursor: "pointer",
    padding: "8px 16px",
    borderRadius: "6px",
    transition: "all 0.2s ease",
  },
  "backButton:hover": {
    backgroundColor: "rgba(88, 166, 255, 0.1)",
    borderColor: "#58A6FF",
    color: "#58A6FF",
  },
  contentGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 2fr",
    gap: "24px",
    alignItems: "flex-start",
  },
  cardHeader: { // NOVO ESTILO
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  cardTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#8B949E",
    margin: "0", // Removido margin-bottom
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  enterpriseCard: {
    backgroundColor: "rgba(22, 27, 34, 0.8)",
    border: "1px solid #30363D",
    borderRadius: "16px",
    padding: "24px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    position: "relative",
  },
  "enterpriseCard:hover": {
    transform: "translateY(-5px)",
    borderColor: "#58A6FF",
    boxShadow: "0 10px 30px rgba(88, 166, 255, 0.1)",
  },
  enterpriseName: {
    fontSize: "20px",
    fontWeight: "600",
    margin: "0 0 8px 0",
    color: "#58A6FF",
  },
  enterpriseInfo: {
    fontSize: "14px",
    color: "#C9D1D9",
    margin: "4px 0",
  },
  cardLink: {
    position: "absolute",
    bottom: "24px",
    right: "24px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#8B949E",
  },
  detailsCard: {
    backgroundColor: "rgba(22, 27, 34, 0.8)",
    border: "1px solid #30363D",
    borderRadius: "16px",
    padding: "24px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  formGroup: {},
  label: {
    fontSize: "12px",
    color: "#8B949E",
    marginBottom: "8px",
    display: "block",
  },
  value: {
    fontSize: "16px",
    fontWeight: "500",
    margin: 0,
    padding: "10px 0",
    height: '38px', // Para alinhar com a altura do input
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    width: "100%",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "6px",
    color: "#E6EDF3",
    padding: "8px 12px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  cardFooter: {
    borderTop: "1px solid #30363D",
    paddingTop: "20px",
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
  },
  actionButton: {
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.2s",
  },
  renewButton: { // NOVO ESTILO
    backgroundColor: '#34D399',
    color: '#0D1117',
    padding: '8px 16px',
    fontSize: '13px'
  },
  editButton: {
    backgroundColor: "rgba(88, 166, 255, 0.2)",
    color: "#58A6FF",
  },
  saveButton: {
    backgroundColor: "#238636",
    color: "#ffffff",
  },
  cancelButton: {
    backgroundColor: "transparent",
    color: "#8B949E",
    border: "1px solid #30363D",
  },
};

export default style;